<template>
  <div style="background-color: #e6e6e6;">
    <HeaderView :title="$t('mine.withdrawdetails')" />
    <div class="view-page">
      <van-pull-refresh
      :pulling-text="$t('common.repulling')"
        :loosing-text="$t('common.reloosing')"
        :loading-text="$t('common.reloading')"
        :success-text="$t('common.resuccess')"
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <van-empty
          v-if="list.length === 0"
          :description="$t('withdraw.empty_data')"
        />
        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="topInfo">
            <span v-if="v.status === 2" style="color: #07c160">{{
              v.status_text
            }}</span>
            <span v-else-if="v.status === 4" style="color: #07c160">{{
              v.status_text
            }}</span>
            <span v-else>{{ v.status_text }}</span>
            <span>{{ $t("withdraw.money") }}：-{{ v.money }}</span>
          </div>
          <div class="desc">
            <span>{{ $t("withdraw.desc") }}：{{ v.desc }}</span>
          </div>
          <div class="time">
            <span>{{ $t("withdraw.submit_time") }}：{{ v.create_time }}</span>
          </div>
          <div class="time">
            <span>{{ $t("withdraw.check_time") }}：{{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import HeaderView from "../../components/Header/index.vue";
export default {
  name: "WithdrawRecord",
  components: { HeaderView },
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList() {
      this.$http({
        method: "get",
        url: "user_get_withdraw_list",
      }).then((res) => {
        if (res.code === 200) {
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login" });
    } else {
      this.getUserWithdrawList();
    }
  },
};
</script>
<style lang="scss" scoped>
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span{
  flex: 1;
  font-weight: 700;
  color: #ff253f;
}
.item_list .time span{
  flex: 1;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{
  float: right;
}
.item_list .desc span{
  font-weight: 700;
  color: #9b9b9b;
}
</style>